import { CalculationFactorKey } from "../../../shared/calculations/calculation-factor-types";

type CuratedListOption = {
  key: CalculationFactorKey;
  label: string;
};

export const curatedListOptions: CuratedListOption[] = [
  { key: CalculationFactorKey.FUGITIVES, label: "Fugitives" },
  { key: CalculationFactorKey.HEATING_AND_FUELS, label: "Heating And Fuel" },
  { key: CalculationFactorKey.TRANSPORT, label: "Transport" },
  { key: CalculationFactorKey.WASTE_CATEGORY, label: "Waste Category" },
  { key: CalculationFactorKey.ELECTRICITY, label: "Electricity" },
  { key: CalculationFactorKey.COOLING, label: "Cooling" },
  { key: CalculationFactorKey.REFRIGERANT, label: "Refrigerant" },
  { key: CalculationFactorKey.MEANS_OF_TRANSPORT, label: "Means of Transport" },
  { key: CalculationFactorKey.HOME_OFFICE, label: "Home Office" },
  { key: CalculationFactorKey.HOTEL_STAYS, label: "Hotel Stays" },
  { key: CalculationFactorKey.FLIGHT_CLASS, label: "Flight Class (Business Travel)" },
  { key: CalculationFactorKey.PRIVATE_AND_RENTAL_VEHICLE, label: "Private and Rental Vehicle (Business Travel)" },
  { key: CalculationFactorKey.CONTINENT_EMPLOYEE_COMMUTING, label: "Continent Employee Commuting" },
  { key: CalculationFactorKey.RAIL_TRAVEL, label: "Rail Travel" },
  { key: CalculationFactorKey.VEHICLE_FUEL_TYPE, label: "Vehicle Fuel Type" },
  { key: CalculationFactorKey.WATER, label: "Water" },
  { key: CalculationFactorKey.BEVERAGES, label: "Beverages" },
  { key: CalculationFactorKey.FOOD, label: "Food" },
];

export const FIRST_CURATED_LIST = curatedListOptions[0].key;
